import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import {connect} from "react-redux";
import {actionCreators} from "../redux/sagas/funnelChart/funnelChart";
import FUNNEL_CONSTANTS from "../constants";

export default connect(
  state => {
    let options = Object.values(FUNNEL_CONSTANTS.START_FROM_OPTIONS);

    return {
      filterType: "Custom Range",
      options,
      placeholder: "Select Range",
      numberDisplayed: 0,
      maxSelect: 1,
      enableMax: true,
      selectedFilters: state.funnelChart.startFrom,
      enableDefaultSelected: true,
      haveOnSelectChange: false
    };
  },
  {
    updateLocations: data => actionCreators.updateStartFrom(data)
  }
)(MultiSelectDropdown);
